import { create } from "zustand";

type TypingState = Record<string, string[]>;

interface TypingStoreType {
  typingState: TypingState;
  setConversationTypingAccounts: (
    conversationId: string,
    setAccounts: (prevAccounts: string[]) => string[],
  ) => void;
}

export default create<TypingStoreType>()((set) => ({
  typingState: {},
  setConversationTypingAccounts: (conversationId, setAccounts) => {
    set((prevState) => {
      const updatedAccounts = setAccounts(
        prevState.typingState[conversationId] || [],
      );
      //remove the conversation key from the typing state if there are no accounts typing
      if (updatedAccounts.length === 0) {
        const { [conversationId]: _, ...rest } = prevState.typingState;
        return { typingState: rest };
      }
      return {
        typingState: {
          ...prevState.typingState,
          [conversationId]: updatedAccounts,
        },
      };
    });
  },
}));
